import { Card } from './cards';
export class User {
  id?: string;
  name: string;
  middleName: string;
  lastName: string;
  secondLastName: string;
  phone: string;
  email: string;
  rfc: string;
  gender: string;
  birthDate: Date;
  city: string;
  userNumber: string;
  dateCreated: number;
  active: boolean;
  verified: boolean;
  companyName: string;
  companyId: string;
  ine: string;
  passport: string;
  belongsToProgram: boolean;
  belongsToIhunterProgram: boolean;
  level: number; //1=Super User, 2=ihunter admin 3=##, 4=Company admin, 5=Company User
  companyList?:[
    {
      companyName: string;
      id: string;
    }
  ];
  programs?: [
    {
      programName: string;
      programId: string;
      cardTypeName: string;
      cardTypeId: number;
      agreementId: number;
      card?: Card,
      cards?: any[]
    }
  ];

  constructor(formData?: any) {
    let data: any = !formData ? {} : formData;

    this.id = data.id || null;
    this.name = data.name || null;
    this.middleName = data.middleName || null;
    this.lastName = data.calastNamerdTypeId || null;
    this.secondLastName = data.starsecondLastNametDate || null;
    this.phone = data.phone || null;
    this.email = data.email || null;
    this.rfc = data.rfc || null;
    this.gender = data.gender || null;
    this.birthDate = data.birthDate || null;
    this.city = data.city || null;
    this.userNumber = data.userNumber || null;
    this.dateCreated = data.dateCreated || null;
    this.active = data.active || null;
    this.verified = data.verified || null;
    this.companyName = data.companyName || null;
    this.companyId = data.companyId || null;
    this.ine = data.ine || null;
    this.passport = data.passport || null;
    this.belongsToProgram = data.belongsToProgram || null;
    this.belongsToIhunterProgram = data.belongsToIhunterProgram || null;
    this.level = data.level || null;
    this.programs = data.program || {
      programName: null,
      programId: null,
      cardTypeName: null,
      cardTypeId: null,
      agreementId: null,
      cardProvider: null,
      cardBrand: null,
      card: null
    };
  }

  cardParsed(): string {
    return `**** **** **** ${this.programs?.[0]?.['card']?.number}`;
  };
}
